export default __webpack_public_path__ + "static/media/OpenSans-Bold.a617006f.woff2";